// extracted by mini-css-extract-plugin
export default {"modal":"LT-z","error":"MT-z","disabled":"NT-z","fields":"OT-z","errorMsg":"PT-z","footer":"QT-z","formContentWrapper":"RT-z","productImage":"ST-z","overlay":"TT-z"};